import { createSupabaseBrowserClient } from '@/client/supabase'
import { useQuery } from '@tanstack/react-query'
import { DBTables } from '../../types/supabaseSugarTypes'
import { subscriptionStatus } from '@/constants/constants'

export const subscriptionKeys = {
  useSubscriptions: (authUserId: string | undefined) =>
    ['subscriptions', String(authUserId)] as const,
  useSubscriptionDetails: (subscriptionId: string) =>
    ['subscription-details', subscriptionId] as const,
}

export const useSubscriptions = (userId: string | undefined) => {
  const supabaseClient = createSupabaseBrowserClient()

  return useQuery({
    queryKey: subscriptionKeys.useSubscriptions(userId),
    queryFn: async () => {
      const { data: subscriptions } = await supabaseClient
        .from('subscriptions')
        .select('*')
        .eq('auth_user_id', userId ?? '')
        .order('started_at', { ascending: false }) //most recent first
        .throwOnError()

      return subscriptions || []
    },
    enabled: !!userId,
  })
}

export const useSubscriptionDetailsQueryFn = async (subscriptionId: string) => {
  const supabase = createSupabaseBrowserClient()

  const { data: members } = await supabase
    .from('subscription_members')
    .select('*, subscriptions!inner(*)')
    .eq('subscription_id', subscriptionId)
    .eq('subscriptions.status', subscriptionStatus.active)
    .order('gh_username')
    .throwOnError()

  return {
    members,
  }
}

export const useSubscriptionDetails = (subscription: DBTables['subscriptions']['Row']) => {
  return useQuery({
    queryKey: subscriptionKeys.useSubscriptionDetails(subscription.id),
    queryFn: () => useSubscriptionDetailsQueryFn(subscription.id),
  })
}
